import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Mail, Instagram, Facebook } from "lucide-react";
import { Logo } from "../components/Logo";
import { NavMenu } from "../components/NavMenu";
import { AceHeart } from "../components/AceHeart";

export default function Contact() {
  return (
    <div className="grain relative min-h-screen overflow-hidden bg-cream text-ink" data-testid="contact-page">
      <img src="/assets/mandala-sun.jpeg" alt="" className="pointer-events-none absolute inset-0 h-full w-full object-cover opacity-[0.12]" />
      <div className="absolute inset-0 bg-gradient-to-b from-cream/70 via-cream/40 to-rosedust/40" />
      <header className="relative z-10 mx-auto flex max-w-5xl items-center justify-between px-4 py-5 sm:px-8">
        <Link to="/" data-testid="contact-home-link"><Logo size={40} /></Link>
        <NavMenu />
      </header>

      <main className="relative z-10 mx-auto max-w-2xl px-4 pb-20 pt-8 sm:px-8">
        <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }} className="text-center">
          <p className="font-cinzel text-xs tracking-[0.35em] text-gold">NOUS ÉCRIRE</p>
          <h1 className="mt-3 font-serif text-4xl font-medium tracking-tight text-ink sm:text-5xl">Contact</h1>
          <p className="mx-auto mt-4 max-w-md font-serif text-base italic leading-relaxed text-clay">
            Une question, une envie, une carte à nous faire retourner ? Écrivez-nous — on vous répond avec le cœur.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
          className="relative mt-10 overflow-hidden rounded-[2rem] border-2 border-gold/50 bg-white/90 shadow-card backdrop-blur-sm"
        >
          <img src="/assets/gift-cards-email.jpeg" alt="Les cartes APINITY" className="h-40 w-full object-cover sm:h-48" />
          <div className="absolute inset-x-0 top-0 h-40 bg-gradient-to-b from-transparent to-white/10 sm:h-48" />
          <div className="p-8 text-center sm:p-10">
            <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-terra/10">
              <Mail size={24} className="text-terra" />
            </div>
            <p className="mt-4 text-sm text-stone2">Notre adresse email</p>
            <a
              href="mailto:apinity78@gmail.com"
              data-testid="contact-email-link"
              className="mt-1 inline-block font-serif text-2xl font-semibold text-terra transition-colors hover:text-terra-dark sm:text-3xl"
            >
              apinity78@gmail.com
            </a>
            <p className="mt-4 text-sm leading-relaxed text-clay">
              Question sur le test, un paiement, une soirée Speed Dating, ou simplement envie de dire bonjour ?
              Nous lisons tout, et nous répondons personnellement.
            </p>
            <a
              href="mailto:apinity78@gmail.com"
              data-testid="contact-write-button"
              className="mt-6 inline-block rounded-full bg-terra px-7 py-3 text-sm font-semibold text-cream shadow-boho transition-all duration-300 hover:scale-[1.03] hover:bg-terra-dark"
            >
              Nous écrire
            </a>
            <div className="mx-auto mt-7 h-px w-24 bg-gold/40" />
            <p className="mt-5 text-xs font-semibold uppercase tracking-[0.25em] text-stone2">Suivre APINITY</p>
            <div className="mt-3 flex items-center justify-center gap-3">
              <a href="https://www.facebook.com/profile.php?id=61582058354625" target="_blank" rel="noreferrer" data-testid="contact-facebook" className="flex h-11 w-11 items-center justify-center rounded-full border border-terra/20 bg-cream text-terra transition-all duration-300 hover:scale-105 hover:border-terra">
                <Facebook size={18} />
              </a>
              <a href="https://www.instagram.com/apinity_france" target="_blank" rel="noreferrer" data-testid="contact-instagram" className="flex h-11 w-11 items-center justify-center rounded-full border border-terra/20 bg-cream text-terra transition-all duration-300 hover:scale-105 hover:border-terra">
                <Instagram size={18} />
              </a>
            </div>
            <p className="mt-6 font-serif text-sm italic text-clay">
              APINITY — L'amour n'est pas un hasard, c'est une carte à tirer. <AceHeart size={13} className="mb-0.5 inline-block" />
            </p>
          </div>
        </motion.div>
      </main>
    </div>
  );
}
